import React from "react";
import Carousel from "../Catalog/Carousel";
import Collection from "../Catalog/Collection";
import Item from "./Item";
import ResizeContext from "./../Contexts/ResizeContext";
import { string, number, bool } from "prop-types";
import axios from "axios";

const templates = {
    carousel: Carousel,
    grid: Collection
};

class CategoryWidget extends React.Component {
    constructor(props){
        super(props);

        this.state = {
            data: [],
            redirections: {}
        };

        this.fetchData = this.fetchData.bind(this);
        this.handleWindowResize = this.handleWindowResize.bind(this);
    }

    componentDidMount() {
        this.fetchData();
        window.addEventListener("resize", this.handleWindowResize);
        this.handleWindowResize();
    }

    fetchData() {
        let query = `?rootCategoryId=${this.props.rootCategoryId}`;

        Promise.all([
            axios.get(`/api/categories${query}`),
            axios.get(`/api/redirections?filter=\\/categories\\/`),
        ]).then(([categoryResults, redirectionResults])=>{
            this.setState({
                data: categoryResults.data.children_data,
                redirections: redirectionResults.data
            });
        }).catch((err)=>{
            console.error(err);
        });
    }

    handleWindowResize() {
        if (!this.state.isMobile && window.innerWidth < 992) {
            this.setState({ isMobile: true });
        } else if (this.state.isMobile && window.innerWidth >= 992) {
            this.setState({ isMobile: false });
        }
    }

    render() {
        const Template = templates[this.props.template];

        return (
            <ResizeContext.Provider
                value={{
                    isMobile: this.state.isMobile
                }}
            >
                <div className="category-widget">
                    <h2 className={`title ${this.state.isMobile && "mobile"}`}>
                        {this.props.title || "Categories"}
                    </h2>
                    <Template
                        data={this.state.data}
                        itemComponent={Item}
                        type={this.props.type}
                        pageSize={this.props.pageSize}
                        pageScroll={this.props.pageScroll}
                        loop={this.props.loop}
                        speed={this.props.speed}
                        autoPlay={this.props.autoPlay}
                        autoPlayInterval={this.props.autoPlayInterval}
                        className="product-grid"
                        redirections={this.state.redirections}
                    />
                </div>
            </ResizeContext.Provider>
        );
    }
}

CategoryWidget.defaultProps = {
    template: "grid",
    type: "equipment",
    rootCategoryId: "24",
    pageSize: 4,
    pageCount: 3,
    pageScroll: 4,
    autoPlay: false,
    autoPlayInterval: 3000,
    speed: 500,
    loop: true
};

CategoryWidget.propTypes = {
    title: string,
    type: string,
    rootCategoryId: string,
    pageSize: number,
    pageCount: number,
    pageScroll: number,
    autoPlay: bool,
    autoPlayInterval: number,
    speed: number,
    loop: bool,
    template: string
};

export {CategoryWidget};
